var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"chart-wrapper"},[_c('echarts',{ref:"chart",attrs:{"options":_vm.options(),"autoresize":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }